import theme from "@/constants/theme";

export const styles: Record<string, React.CSSProperties> = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    padding: 16,
    paddingTop: 32,
  },
  cover: {
    width: "auto",
    height: "200px",
    objectFit: "cover",
    borderRadius: "8px",
    backgroundColor: theme.colors.background.secondary,
  },
  badge: {
    padding: 8,
    backgroundColor: theme.colors.background.secondary, 
    borderRadius: 4,
  }
};